/* eslint-disable @typescript-eslint/no-unused-vars */
import {
	Banner,
	Container,
	CustomButton,
	DataContainer,
	ItemImage,
	Items,
	Offer,
	OfferItem,
	OffersContainer,
	PoisBountyLabel,
	RewardAmount,
	RewardAmountContainer,
	RewardItem,
	SubTitle,
	Title
} from "./styles";
import CountdownV2 from "components/CountdownV2";
import useRewardsById from "hooks/useRewardsById";
import type { FriendShopOffer } from "interfaces/friend-shop";
import { InfoBanner } from "./InfoBanner";
import { sortBundleRewards } from "helpers/rewardSort";
import { useAppSelector } from "hooks";
import { selectPoisBountyV3State } from "redux/slices";
import { friendShopAPI } from "redux/apis/friendShop";
import { useEffect } from "react";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import DebugCopyIdButton from "debug/components/DebugCopyIdButton";

interface Props {
	shopOffer: FriendShopOffer;
	onSelect: () => void;
}

const GiftItem = ({ shopOffer, onSelect }: Props) => {
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { nowTime } = useWebStoreContext();
	const { refetch } =
		friendShopAPI.endpoints.getGiftsFriendShop.useQuerySubscription(undefined);
	const { eventActive: isPoisActive } = useAppSelector(selectPoisBountyV3State);

	useEffect(() => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "friend_shop_offer_rendered",
			event_type: "friend_shop_offer",
			action: "offer_rendered",
			source: "friend_shop",
			offer_id: shopOffer.offerId,
			reward_id: `${shopOffer.offer.rewardId};${shopOffer.gifterBonusRewardId}`,
			price_in_cents: Math.round((shopOffer.offer.price ?? 0) * 100)
		});
	}, []);

	const priceText = shopOffer?.offer?.price
		? `${shopOffer.offer.price} USD`
		: "";

	const friendRewardItems = useRewardsById(shopOffer.offer?.rewardId || "");
	const rewardItems = useRewardsById(shopOffer.gifterBonusRewardId);
	const orderedFriendRewardItems = sortBundleRewards(friendRewardItems);
	const orderedRewardItems = sortBundleRewards(rewardItems);

	const handleSelect = () => {
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "friend_gift_click",
			event_type: "friend_shop_offer",
			action: "click",
			source: "friend_shop",
			offer_id: shopOffer.offerId,
			reward_id: `${shopOffer.offer.rewardId};${shopOffer.gifterBonusRewardId}`,
			price_in_cents: Math.round((shopOffer.offer.price ?? 0) * 100)
		});

		onSelect();
	};

	return (
		<>
			{shopOffer.endTime && nowTime && (
				<CountdownV2
					text=""
					startTime={nowTime}
					endTime={shopOffer.endTime}
					onEnd={() => {
						setTimeout(() => {
							void refetch();
						}, 1000);
					}}
					style={{ display: "none" }}
					hideTimerDisplayOnEnd
				/>
			)}
			<Container
				style={{
					backgroundImage: `url(${shopOffer.backgroundImageUrl})`,
					borderColor: shopOffer.outlineColorHex || "#277aac",
					height: isPoisActive ? "23.5em" : "22.31em"
				}}
			>
				<DebugCopyIdButton
					id={shopOffer.offerId}
					label="OfferID"
					side="right"
					vertical="top"
					style={{ top: "12%", fontSize: "0.8em", zIndex: 1 }}
				/>
				<Banner style={{ backgroundImage: `url(${shopOffer.bannerImageUrl})` }}>
					<Title>{shopOffer.bannerText}</Title>
				</Banner>
				<DataContainer>
					<OffersContainer>
						<Offer>
							<SubTitle>Your friend gets:</SubTitle>
							<OfferItem>
								<Items>
									{orderedFriendRewardItems.map(
										({ imageUrl, description }, key) => {
											return (
												<RewardItem
													className="imgWrap"
													key={key}
													//width={100 / orderedFriendRewardItems.length + "%"}
													width={"25%"}
												>
													<ItemImage src={imageUrl} alt="" />
													<RewardAmountContainer>
														<RewardAmount>{description}</RewardAmount>
													</RewardAmountContainer>
												</RewardItem>
											);
										}
									)}
								</Items>
							</OfferItem>
						</Offer>
						<Offer>
							<SubTitle>And you get:</SubTitle>
							<OfferItem>
								<Items>
									{orderedRewardItems.map(({ imageUrl, description }, key) => {
										return (
											<RewardItem className="imgWrap" key={key} width={"25%"}>
												<ItemImage src={imageUrl} alt="" />
												<RewardAmountContainer>
													<RewardAmount>{description}</RewardAmount>
												</RewardAmountContainer>
											</RewardItem>
										);
									})}
								</Items>
								<InfoBanner text={priceText} text2={priceText} />
							</OfferItem>
						</Offer>
					</OffersContainer>
					<CustomButton
						variant="contained"
						color="success"
						size="large"
						onClick={handleSelect}
					>
						Gift to a Friend
					</CustomButton>
					{/*
						{isPoisActive && (
							<PoisBountyLabel>Contribute to Poi&apos;s Bounty</PoisBountyLabel>
						)}
					*/}
				</DataContainer>
			</Container>
		</>
	);
};

export default GiftItem;
